import { createFromIconfontCN } from '@ant-design/icons';

const parkUrl =
  'https://lf1-cdn-tos.bytegoofy.com/obj/iconpark/svg_10980_45.3ac02b63fad6b15638509e4d3513b39c.js';

export default createFromIconfontCN({
  scriptUrl: parkUrl,
});
